<template>
  <div class="privacy-policy">
    <div class="section" v-loading="loading">
      <div class="section-content">
        <p class="title">PRIVACY POLICY</p>
        <p>
          This Privacy Policy is part of our Flatknockers Private Limited’s Terms of Service. 
          Therefore, by accepting the Terms of Service and Privacy Policy on our log-in / registration page, 
          you understand the purpose and agree to share your personal information.Kindly read this Privacy Policy 
          carefully before using any Rummy’s services. We request you to refrain from registering if you do not 
          wish to share your information with app (hereinafter referred to as "Rummy" or "we" or "us" or "our") 
          since the information is mandatory and is requested at the time of registration. Please note that all 
          non-optional fields are required to be completed and your registration shall not be complete until 
          information sought in the non-optional fields is provided. Additional personal information may or may 
          not be requested by Rummy for permitting you access to some Cash Tables available on our platform.
        </p>
        <p>
          1. What is the Privacy Policy About?
        </p>
        <p>
          Rummy respects your privacy and assures you that any information provided by you is protected and 
          adheres to all Policies and the applicable laws. In order to get access to the services offered on 
          us (hereinafter referred to as the "App"), certain information needs to be provided to us.
        </p>
        <p>
          This Policy outlines the procedure followed by Rummy to gather, use, store and manage users' personal data.
          Collection of personal data is only for the purpose of verifying user accounts, maintaining the accounts 
          of users, completing transactions initiated by users and for analyzing user behavior to fulfill the 
          needed requirements. We aim to protect users data with transparency, accuracy and confidentiality.
        </p>
        <p>
          2. What is included in personal data?
        </p>
        <p style="font-weight: 800;">
          USERS’ PERSONAL DATA INCLUDES THE FOLLOWING TYPES OF PERSONAL DATA OR INFORMATION:
        </p>
        <p>
          1. Confidential Personal Data Account password ( stored encrypted ) Financial Details such as 
          Bank Account, Credit Card, Debit Card or other payment details
        </p>
        <p>
          2. Other Personal Information Name Date of birth Telephone number Address Proof PAN Number The IP address 
          of your computer, browser type and language. The date and the time of your accessing the site. 
          Active and current Location while Live on App. The address that you may have used to link to our Website 
          Your photograph for the purpose of testimonials and other promotions. Any other information that is 
          defined as "sensitive personal data or information" in law.
        </p>
        <p>
          3. Users’ Consent for the Above Consent to the use of Sensitive Personal Data and Other Personal 
          Information All users of Rummy consent to the use of their Confidential Personal Data and Other Personal 
          Information by us for the purposes stated in this policy. Access to all information is restricted and 
          only shared with those who need to know such information in order to process, operate or resolve 
          information on our behalf.
        </p>
        <p>
          Users are allowed to withdraw consent to the use of their Confidential Personal Data or Other Personal 
          Information by contacting our customer support. Withdrawal of consent to use all or any part of 
          Sensitive Personal Data and Other Personal Information may result in immediate withdrawal of any right 
          provided to the user to use the services provided by Rummy.
        </p>
        <p>
          Withdrawal of consent by users shall not restrict the right of Rummy to use Other Personal Information 
          for the analysis of user data, subject to the condition that the Other Personal Information used in 
          such analysis is not personally identifiable to any individual user.
        </p>
        <p>
          Users’ providing photographs to Rummy for marketing purposes gives Rummy irrevocable rights to use them 
          and it is solely Rummy's discretion to delete or not use them any further.
        </p>
        <p>
          Rummy may also use software applications for Website traffic analysis and to gather statistics, 
          used for advertising and for determining the efficacy and popularity of Rummy and other such purposes.
        </p>
        <p>
          CONSENT TO EMAIL COMMUNICATION When you register your email address with Rummy, 
          you agree to receive email communication from Rummy. You also agree and acknowledge that when you use 
          our referral program for referring someone, e-mails may be sent to the person referred by you on your 
          behalf and the email headers will carry your email address as the address from which such emails are sent.
        </p>
        <p>
          Rummy may also access and store such information relating to your contacts to send invitations and 
          other promotions to them periodically.
        </p>
        <p>
          CONSENT TO TELEPHONIC COMMUNICATION Any telephonic communication between you and our Customer Support 
          representatives may be recorded for the purposes of employee training and quality management.
        </p>
        <p>
          4. Data Security
        </p>
        <p>
          We take considerate security measures to protect user data from unauthorized access, alteration, 
          disclosure or destruction. Measures taken include internal mapping of our data collection, 
          storage and processing practices. Adequate security measures include encryption and physical security 
          measures to prevent any unauthorized access.
        </p>
        <p>
          Information gathered by Rummy is stored securely using several information security applications behind 
          firewalls. However, security is always relative and Rummy cannot guarantee that its security measures are 
          absolute and cannot be breached. Data transmitted over the Internet is inherently exposed to security 
          risks or threats. For instance, the security of information transmitted via chat or email might be 
          compromised and such information may be used by others. Therefore, Rummy cannot guarantee any security for 
          such information in the course of transmission through the internet infrastructure or any unsolicited 
          disclosures made by any users using the services of the app.
        </p>
        <p>
          When you register with Rummy, your account is protected with login information, including a username and 
          a password, known only to you. We request you not to provide your personal information to anyone whosoever.
          If you are aware of or suspect any breach of security, including compromise of your login information, 
          it is your responsibility to immediately notify Rummy.
        </p>
        <p>
          You might be exposed to third Party Websites. Such websites are governed by their own privacy policies, 
          and Rummy does not exercise any control over them. It is your responsibility to read and understand the 
          privacy policy of such websites when you visit them following provided links. You are advised to exercise 
          caution in sharing any personal information with any third party that advertises on the Website: Rummy 
          shall not be responsible for the information provided by you on or to third party websites.
        </p>
        <p>
          Rummy has a policy of not sharing any information with anyone other than specifically authorized entities 
          by Rummy, which may include advertisers and sponsors of Rummy. However, Rummy may use information 
          like your name, photo, login ID and the state from where you are participating when announcing the results 
          of any contests hosted on the Website. Such contests are further governed by terms and conditions, 
          which shall be available on the Website/app as and when such contests are hosted. Rummy conducts periodic 
          analysis and survey of the traffic to rummy for market research and advertising purposes. Rummy reserves 
          the right to share your registration information with Rummy-appointed market research and advertising 
          companies or firms from time to time for the said purposes. Rummy may also use cumulative non-personal 
          information for auditing and analysis purposes with the aim of improving its services
        </p>
        <p>
          5. Privacy measures for minors
        </p>
        <p>
          Our App are only applicable to users above the age of 18. If you are under 18 years of age, you are not 
          permitted to use our App for game plays. If you are a parent and/or guardian and believe that we may have 
          inadvertently collected personal information from your child, you can notify us immediately by sending
          message on customer support
        </p>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // loading: true,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  }
  // mounted() {
  //   this.$http
  //     .all([
  //       this.$http.get("Honor/GetHonorAll"),
  //       this.$http.get("Enterprise/GetEnterpriseAll"),
  //       this.$http.get(`Team/GetTeamAll`),
  //       this.$http.get(`Course/GetCourseAll`)
  //     ])
  //     .then(
  //       this.$http.spread(
  //         (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
  //           this.honorList = responseHonor.data;
  //           this.partnerImg = responseEnterprise.data;
  //           this.teamItem = responseTeam.data;

  //           var groupCount = Math.ceil(responseCourse.data.length / 2);
  //           window.console.log(groupCount);
  //           for (let i = 0; i < groupCount; i++) {
  //             let img2 = [];
  //             for (let j = 0; j < 2; j++) {
  //               if (responseCourse.data.length - 1 >= i * 2 + j) {
  //                 img2.push(responseCourse.data[i * 2 + j]);
  //               }
  //             }
  //             this.courseList.push(img2);
  //           }
  //           window.console.log(this.courseList);
  //           this.loading = false;
  //         }
  //       )
  //     );
  // }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.privacy-policy {
  width: 100%;
  height: 100%;
  // background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    width: 62%;
    margin-left: 19%;
    font-family: PingFangSC-Regular;
    font-size: 20px;
    letter-spacing: 0;
    font-weight: 400;

    &-content {

      .title {
        width: 100%;
        font-size: 24px;
        text-align: center;
        margin-top: 26px;
        margin-bottom: 20px;
      }
      .p2 {
        margin: 15px 0;
      }
      
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>